import api from '@/api/index.js'

const operator_bot_clients = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_OPERATOR_BOT_CLIENTS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_OPERATOR_BOT_CLIENTS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_OPERATOR_BOT_CLIENTS_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    GetOperatorBotClients({commit}, query) {
      commit('SET_OPERATOR_BOT_CLIENTS', [])
      commit('SET_OPERATOR_BOT_CLIENTS_ERROR', null)
      commit('SET_OPERATOR_BOT_CLIENTS_LOADING', true)
      return api.get(`operators/${query.operatorId}/bot-clients`)
        .then((response) => {
          commit('SET_OPERATOR_BOT_CLIENTS', response)
        })
        .catch((error) => {
          commit('SET_OPERATOR_BOT_CLIENTS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OPERATOR_BOT_CLIENTS_LOADING', false)
        })
    },
  }
}

export default operator_bot_clients
